import HomepageContent from './HomepageContent';
import './styles.scss';
import 'uplot/dist/uPlot.min.css';

export default function Homepage() {
  return (
      <HomepageContent />
  );
}
